<template>
  <div>
    <FloatIcon :cart="cart" />
    <MainContent
      :products="products"
      :cart="cart"
      :cartSubTotal="cartSubTotal"
      :orderSummary="orderSummary"
      :shippingDetails="shippingDetails"
      :updatedShipping="updatedShipping"
      :shippingCollapse="shippingCollapse"
      :reviewCollapse="reviewCollapse"
      :pageLoading="pageLoading"
      :promoCode="promoCode"
      :promoProcessing="promoProcessing"
      :responseMessages="responseMessages"
      :giftMsgCheck="giftMsgCheck"
      :greetingMessage="greetingMessage"
      :senderName="senderName"
      :deliveryDate="deliveryDate"
      :currency="currency"
      :vendorName="vendor"
      :appId="app_id"
    />
    <ProductModal
      :singleProduct="singleProduct"
      :priceUnit="priceUnit"
      :showVariantErrorMsg="showVariantErrorMsg"
    />
    <CartModal
      :products="products"
      :cart="cart"
      :cartSubTotal="cartSubTotal"
      :priceUnit="priceUnit"
      :cartLoading="cartLoading"
    />
    <FooterModal />
  </div>
</template>

<script>
import FloatIcon from "./components/FloatIcon.vue";
import MainContent from "./components/MainContent.vue";
import ProductModal from "./components/ProductModal.vue";
import CartModal from "./components/CartModal.vue";
import FooterModal from "./components/FooterModal.vue";

import axios from "axios";
import bootstrap from "./assets/js/bootstrap.min.js";

export default {
  name: "App",
  components: {
    FloatIcon,
    MainContent,
    ProductModal,
    CartModal,
    FooterModal,
  },
  data() {
    return {
      base_url: process.env.VUE_APP_ROOT_API,
      env_mode: process.env.VUE_APP_MODE,
      products: [],
      cart: [],
      quantity: 1,
      priceUnit: null,
      cartId: "",
      cartSubTotal: 0,
      removedItems: [],
      currency: null,
      singleProduct: null,
      cartLoading: false,
      pageLoading: false,
      cartModal: null,
      productModal: null,
      shippingCollapse: null,
      reviewCollapse: null,
      shippingDetails: {
        first_name: "",
        email: "",
        phone: "",
        address_1: "",
        address_2: "",
        city: "",
        postcode: "",
        state: "KUL",
        country: "MY",
        remark: "",
      },
      orderSummary: {
        total: 0,
        id: "",
        products: [],
      },
      shippingLines: [],
      savedShippingDetails: null,
      updatedCart: false,
      updatedShipping: false,
      showVariantErrorMsg: false,
      promoCode: "",
      promoProcessing: false,
      mainProduct: null,
      addItemParam: 0,
      responseMessages: null,
      faqModal: null,
      tncModal: null,
      firstLoad: true,
      giftMsgCheck: false,
      greetingMessage: "",
      savedGreetingMessage: "",
      senderName: "",
      savedSenderName: "",
      deliveryDate: null,
      app_id: process.env.VUE_APP_APPID,
      vendor: process.env.VUE_APP_VENDOR,
      savedDeliveryDate: null,
      savedGiftMsgCheck: false,
    };
  },
  methods: {
    getProductList: function () {
      axios
        .get(this.base_url + "/"+ this.vendor+"/" + "get-products", {
          params:{
            "app_id": this.app_id
          }
        })
        .then((response) => {
          this.products = response.data.result;
          this.currency = this.products.currency;
          this.priceUnit = this.products.currency_symbol;
          this.products.product = this.products.products;

          //remove product with status "draft"
          // let tempProduct = this.products.products;
          // tempProduct.forEach(function (item, index) {
          //   if(item.status == "draft") {
          //     tempProduct.splice(index, 1);
          //   }
          // });
          // this.products.product = tempProduct;


          //rearrange product according to price
          this.products.product = this.products.product.sort(function (a, b) {
            return a.price - b.price;
          });

          this.products.product.forEach((data) => {
            this.$set(data, "app_id", this.app_id);
            this.$set(data, "quantity", 1);
          });

          //get product from param /product/{id}
          if (this.$route.params.id) {
            let product = this.products.product.filter(
              (product) => product.id === this.$route.params.id
            );

            if (product.length > 0) {
              this.mainProduct = product[0];
            } else {
              this.mainProduct = this.products.product[0];
            }
          } else {
            this.mainProduct = this.products.product[0];
          }

          /** to check if there is any invalid item */
          let toUpdateCart = false;
          let i;
          for (i = this.cart.length - 1; i >= 0; i--) {
            if (this.products.product) {
              let item = this.products.product.filter(
                (item) => item.id === this.cart[i].id
              );

              if (item.length > 0) {
                this.$set(
                  this.cart[i],
                  "stock_quantity",
                  item[0].stock_quantity
                );
                if (item[0].selections.length > 0) {
                  if (!this.cart[i].variation_id) {
                    /** remove invalid item from cart */
                    this.removeCartItem(i, this.cart[i]);
                    toUpdateCart = true;
                  } else {
                    let option_list = [];
                    this.cart[i].selections = this.cart[i].variations;
                    this.cart[i].selections.forEach((vdata) => {
                      vdata.selected_option = vdata.value;
                      option_list.push(vdata.value);
                    });
                    this.cart[i].option_list = option_list;
                  }
                }
              } else {
                /** remove invalid item from cart */
                this.removeCartItem(i, this.cart[i]);
                toUpdateCart = true;
              }
            }
          }

          if (toUpdateCart) {
            if (this.cart.length > 0) {
              this.updateCart();
            }
          }
          /** end to check if there is any invalid item */
          this.getItemFromParam();
        })
        .catch((errors) => {
          console.log(errors);
        });
    },

    getCart: function (updateCart) {
      axios
        .get(this.base_url + "/"+ this.vendor+"/" + "get-cart?cart_id=" + this.cartId)
        .then((response) => {
          let cartData = response.data;
          if (cartData.status_matched) {
            this.orderSummary = JSON.parse(JSON.stringify(cartData));
            this.shippingDetails = cartData.shipping;
            this.shippingDetails["email"] = cartData.billing["email"];
            this.billlingDetails = cartData.billing;
            this.savedShippingDetails = JSON.parse(
              JSON.stringify(this.shippingDetails)
            );
            this.savedDeliveryDate = cartData.delivery_date;
            this.savedGreetingMessage = cartData.greeting_message;
            this.savedSenderName = cartData.sender_name;
            if(cartData.greeting_message ||cartData.sender_name){
              this.savedGiftMsgCheck = true;
            }
            
            if (this.getCookie("pureeciousCart")) {
              let cartCookie = this.getCookie("pureeciousCart");
              this.orderSummary.order_id = cartCookie.order_id;
            }

            this.orderSummary.products.forEach((data) => {
              this.$set(data, "app_id", this.app_id);
              this.$set(data, "images", [data.image]);
              this.$set(data, "subtotal", data.sub_amount);

              let option_list = [];
              data.selections = data.variations;
              data.selections.forEach((vdata) => {
                vdata.selected_option = vdata.value;
                option_list.push(vdata.value);
              });
              data.option_list = option_list;
            });

            if (
              this.shippingDetails.first_name &&
              this.shippingDetails.email &&
              this.shippingDetails.phone &&
              this.shippingDetails.address_1 &&
              this.shippingDetails.city &&
              this.shippingDetails.postcode &&
              this.shippingDetails.state &&
              this.shippingDetails.country
            ) {
              this.updatedShipping = true;
            }

            if (updateCart) {
              this.setSpecificCartData(cartData);
            }
          }

          this.promoProcessing = false;
          this.getItemFromParam();

          if (cartData.promocodes != null && cartData.promocodes != "" && cartData.promocodes != "null") {
            if (this.firstLoad) {
              this.getPromoCode(cartData.promocodes);
            }
            this.promoCode = cartData.promocodes;
          } else {
            if (this.getCookie("promoCode")) {
              this.promoCode = this.getCookie("promoCode").promoCode;
            }
          }
          this.deliveryDate = cartData.delivery_date;
          this.greetingMessage = cartData.greeting_message;
          this.senderName = cartData.sender_name;
          if(this.greetingMessage){
            this.giftMsgCheck = true;
          }
          this.firstLoad = false;
        })
        .catch((errors) => {
          console.log(errors);
        });
    },

    showProductModal: function (product) {
      if (product && product.images.length) {
        this.$set(product, "main_image", product.images[0]);
      } else {
        this.$set(product, "main_image", "");
      }

      this.singleProduct = product;
      this.showVariantErrorMsg = false;
    },

    increaseQuantity: function (itemToIncrease) {
      if (
        (!itemToIncrease.stock_quantity && itemToIncrease.stock_quantity !=0) ||
        itemToIncrease.quantity < itemToIncrease.stock_quantity
      ) {
        itemToIncrease.quantity += 1;
      }
    },

    reduceQuantity: function (itemToReduce) {
      if (itemToReduce.quantity > 1) {
        itemToReduce.quantity -= 1;
      }
    },

    increaseQuantityInCart: function (cartItem) {
      if (
        (!cartItem.stock_quantity && cartItem.stock_quantity !=0)||
        cartItem.quantity < cartItem.stock_quantity
      ) {
        cartItem.quantity = cartItem.quantity + 1;
        cartItem.subtotal = cartItem.quantity * cartItem.price;
        this.calCartSubTotal();
      }
    },

    reduceQuantityInCart: function (cartItem) {
      if (cartItem.quantity > 1) {
        cartItem.quantity = cartItem.quantity - 1;
        cartItem.subtotal = cartItem.quantity * cartItem.price;
        this.calCartSubTotal();
      }
    },

    addToCart: function (product) {
      if (product.selections.length > 0) {
        let option_list = [];
        this.showVariantErrorMsg = false;
        product.selections.forEach((selection) => {
          if (!selection.selected_option) {
            this.showVariantErrorMsg = true;
            return;
          } else {
            option_list.push(selection.selected_option);
          }
        });

        if (this.showVariantErrorMsg) {
          return false;
        } else {
          product.option_list = option_list;
        }
      }

      let itemInCart = this.cart.filter(function (item) {
        if (item.product_id) {
          if (item.product_id == product.id) {
            return item;
          }
        } else {
          if (item.id == product.id) {
            if (
              JSON.stringify(product.option_list) ==
              JSON.stringify(item.option_list)
            ) {
              return item;
            }
          }
        }
      });

      let isItemInCart = itemInCart.length > 0;
      let thisItem = JSON.parse(JSON.stringify(product));

      if (isItemInCart === false) {
        thisItem.subtotal = thisItem.quantity * Number(thisItem.price);
        this.cart.push(thisItem);
      } else {
        itemInCart[0].quantity = itemInCart[0].quantity + thisItem.quantity;
        if (itemInCart[0].stock_quantity) {
          if (itemInCart[0].quantity > itemInCart[0].stock_quantity) {
            itemInCart[0].quantity = itemInCart[0].stock_quantity;
          }
        }

        itemInCart[0].subtotal = itemInCart[0].quantity * thisItem.price;
      }

      this.calCartSubTotal();

      product.quantity = 1;
      this.productModal.hide();
      this.cartModal.show();
    },

    removeCartItem: function (index, itemToRemove) {
      itemToRemove.quantity = 0;
      this.cart.splice(index, 1);
      this.calCartSubTotal();

      if (this.cart.length <= 0) {
        this.orderSummary = {
          total: 0,
          id: "",
          products: [],
        };
      }
    },

    updateCart: function () {
      if (this.cartLoading) {
        return;
      }

      let firstorder = false;
      if (this.cartId == "") {
        firstorder = true;
      }

      let formData = new FormData();
      formData.append("cart_id", this.cartId);
      formData.append("delivery_date", this.deliveryDate);
      if (this.giftMsgCheck) {
        formData.append("greeting_message", this.greetingMessage);
        formData.append("sender_name", this.senderName);
      }

      /** checkout - create or update cart */
      this.cartLoading = true;
      let url = "";
      if (firstorder) {
        url = "create-cart";
        formData.append(
          "app_id", this.app_id
        );
        formData.append(
          "shipping_details",
          JSON.stringify(this.shippingDetails)
        );
        formData.append(
          "billing_details",
          JSON.stringify(this.shippingDetails)
        );
        
        formData.append("cart", JSON.stringify(this.cart));
      } else {
        url = "update-cart";

        formData.append("promocode", this.promoCode);        
        formData.append(
          "shipping_details",
          JSON.stringify(this.savedShippingDetails)
        );
        formData.append(
          "billing_details",
          JSON.stringify(this.savedShippingDetails)
        );
        formData.append("cart", JSON.stringify(this.cart));
      }

      axios
        .post(this.base_url + "/"+ this.vendor+"/" + url, formData)
        .then((response) => {
          this.removeProductParam(); //remove param before

          let cartData = response.data;

          this.responseMessages = cartData.messages;

          if (
            cartData.status_updated == true ||
            cartData.status_created == true
          ) {
            this.cartId = cartData.cart_id;

            // set true - update cart
            // set false - don't want update cart , set this when want to compare old and new cart
            this.getCart(true);

            this.updatedCart = true;

            if (this.getCookie("pureeciousCart")) {
              let cartCookie = this.getCookie("pureeciousCart");
              if (cartCookie.order_id) {
                cartCookie.updatedCart = true;
                this.setCookie("pureeciousCart", JSON.stringify(cartCookie), 1);
              }
            }
            this.cartModal.hide();

            if (!this.validateShipping(true)) {
              this.shippingCollapse.show();
              this.reviewCollapse.hide();
              document.getElementById("shipping-sec").scrollIntoView();
            } else {
              if (firstorder) {
                this.shippingCollapse.hide();
                this.reviewCollapse.show();
                document.getElementById("review-sec").scrollIntoView();
              } else if (this.responseMessages.sender_name) {
                this.shippingCollapse.show();
                this.reviewCollapse.hide();
                document.getElementById("shipping-sec").scrollIntoView();
              } else if (this.promoProcessing) {
                this.shippingCollapse.hide();
                this.reviewCollapse.show();
                document.getElementById("review-sec").scrollIntoView();
              } else {
                this.shippingCollapse.show();
                this.reviewCollapse.show();
                document.getElementById("shipping-sec").scrollIntoView();
              }
            }
          } else {
            this.$swal({
              icon: "error",
              title: "Oops...",
              text: "Something went wrong.",
            });
          }

          this.cartLoading = false;
        })
        .catch((errors) => {
          console.log(errors);
        });
    },

    updateShipping: function () {
      if (this.pageLoading) {
        return;
      }

      this.pageLoading = true;

      let formData = new FormData();
      formData.append("cart_id", this.cartId);

      // if(!this.deliveryDate) {
      //   this.$swal({
      //       icon: "error",
      //       title: "Please fill in all the required fields.",
      //     });
      //     this.pageLoading = false;
      //     return false;
      // }else{        
      //   formData.append("delivery_date", this.deliveryDate);
      // }
      
      if (this.giftMsgCheck) {
        formData.append("greeting_message", this.greetingMessage);
        formData.append("sender_name", this.senderName);
      }

      if (this.validateShipping(false)) {
        if (
          this.orderSummary.products.length > 0 
          // &&
          // JSON.stringify(this.shippingDetails) !=
          //   JSON.stringify(this.savedShippingDetails)
        ) {
          formData.append("promocode", this.promoCode);
          formData.append(
            "shipping_details",
            JSON.stringify(this.shippingDetails)
          );
          formData.append(
            "billing_details",
            JSON.stringify(this.shippingDetails)
          );
          
          formData.append("cart", JSON.stringify(this.orderSummary.products));
        } else {
          this.shippingCollapse.hide();
          this.reviewCollapse.show();
          document.getElementById("review-sec").scrollIntoView();
          this.pageLoading = false;
          return;
        }
      } else {
        this.pageLoading = false;
        return;
      }
      axios
        .post(this.base_url + "/"+ this.vendor+"/" + "update-cart", formData)
        .then((response) => {
          let cartData = response.data;
          this.responseMessages = cartData.messages;

          if (cartData.status_updated == true) {
            this.cartId = cartData.cart_id;

            // set true - update cart
            // set false - don't want update cart , set this when want to compare old and new cart
            this.getCart(true);

            this.updatedCart = true;

            if (this.getCookie("pureeciousCart")) {
              let cartCookie = this.getCookie("pureeciousCart");
              if (cartCookie.order_id) {
                cartCookie.updatedCart = true;
                this.setCookie("pureeciousCart", JSON.stringify(cartCookie), 1);
              }
            }

            if (this.responseMessages.sender_name) {
              this.shippingCollapse.show();
              this.reviewCollapse.hide();
              document.getElementById("shipping-sec").scrollIntoView();
            }else{
              this.shippingCollapse.hide();
              this.reviewCollapse.show();
              document.getElementById("review-sec").scrollIntoView();
            }
          } else {
            this.$swal({
              icon: "error",
              title: "Oops...",
              text: "Something went wrong.",
            });
          }

          this.pageLoading = false;
        })
        .catch((errors) => {
          console.log(errors);
        });
    },

    checkout: function (submitForm) {      

      let formData = new FormData();
      formData.append("cart_id", this.cartId);

      if (this.getCookie("pureeciousCart")) {
        let cartCookie = this.getCookie("pureeciousCart");
        if (cartCookie.order_id) {
          if (this.updatedCart || cartCookie.updatedCart) {
            formData.append("re_checkout", true);
          }
        }
      }

      /** place order */
      if (this.pageLoading) {
        return;
      }
      this.pageLoading = true;
      if (!this.validateShipping(false)) {
        this.shippingCollapse.show();
        this.reviewCollapse.hide();
        document.getElementById("shipping-sec").scrollIntoView();
        this.pageLoading = false;
        return;
      }

      Object.keys(this.shippingDetails).forEach((key) => {
        if (this.shippingDetails[key] == "") {
          this.shippingDetails[key] = null;
        }
      });

      Object.keys(this.savedShippingDetails).forEach((key) => {
        if (this.savedShippingDetails[key] == "") {
          this.savedShippingDetails[key] = null;
        }
      });

      if (
        JSON.stringify(this.shippingDetails) !=
        JSON.stringify(this.savedShippingDetails)
      ) {
        this.$swal({
          icon: "warning",
          title:
            "You have changed your Shipping Address detail, please click Continue to save it before proceed to Place Order.",
        });
        this.pageLoading = false;
        return;
      }

      if ( this.deliveryDate!=this.savedDeliveryDate        
      ) {
        this.$swal({
          icon: "warning",
          title:
            "You have changed your Delivery Date, please click Continue to save it before proceed to Place Order.",
        });
        this.pageLoading = false;
        return;
      }

      if ( this.giftMsgCheck!=this.savedGiftMsgCheck        
      ) {
        this.$swal({
          icon: "warning",
          title:
            "You have changed your Gift Message detail, please click Continue to save it before proceed to Place Order.",
        });
        this.pageLoading = false;
        return;
      }

      if ( this.greetingMessage!=this.savedGreetingMessage     
      ) {
        this.$swal({
          icon: "warning",
          title:
            "You have changed your Greeting Message, please click Continue to save it before proceed to Place Order.",
        });
        this.pageLoading = false;
        return;
      }

      if ( this.senderName!=this.savedSenderName        
      ) {
        this.$swal({
          icon: "warning",
          title:
            "You have changed your Sender Name, please click Continue to save it before proceed to Place Order.",
        });
        this.pageLoading = false;
        return;
      }

      if (this.responseMessages && this.responseMessages.sender_name) {
        this.shippingCollapse.show();
        this.reviewCollapse.hide();
        document.getElementById("shipping-sec").scrollIntoView();
        this.pageLoading = false;
        return;
      }
      
      axios
        .post(this.base_url + "/"+ this.vendor+"/" + "checkout", formData)
        .then((response) => {
          let cartData = response.data;
          if (cartData.order_id) {
            this.setCookie(
              "pureeciousCart",
              '{"cart_id": "' +
                cartData.cart_id +
                '", "email": "' +
                this.savedShippingDetails.email +
                '", "payment": "pending", "order_id": "' +
                cartData.order_id + '", "total_amount": "' + cartData.total_amount+
                '"}',
              1
            );

            //if local storage has kol id
            if(this.getCookie("kol_id")){
              this.setCookie(
              "pureeciousKOLDetails",
              '{"order_id": "' +
                cartData.order_id + '", "total_amount": "' + cartData.total_amount+
                '"}',
              1
            );
            }

            this.orderSummary.order_id = cartData.order_id;
            document.getElementsByName("OrderID")[0].value = cartData.order_id;
            this.updatedCart = false;

            submitForm.submit();
          } else {
            this.$swal({
              icon: "error",
              title: "Oops...",
              text: "Something went wrong.",
            });
          }

          this.cartLoading = false;
          this.pageLoading = false;
        })
        .catch((errors) => {
          console.log(errors);
        });
    },

    validateShipping: function (fromCheckout) {
      if (
        !this.shippingDetails.first_name ||
        !this.shippingDetails.email ||
        !this.shippingDetails.phone ||
        !this.shippingDetails.address_1 ||
        !this.shippingDetails.city ||
        !this.shippingDetails.postcode ||
        !this.shippingDetails.state ||
        !this.shippingDetails.country
      ) {
        if (!fromCheckout) {
          this.$swal({
            icon: "error",
            title: "Please fill in all the required fields.",
          });
        }

        return false;
      }

      // validate email
      let re =
        /^([\w-]+(?:\.[\w-]+)*)@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$/i;
      if (!re.test(this.shippingDetails.email)) {
        this.$swal({
          icon: "error",
          title: "Invalid email.",
        });
        return false;
      }

      // validate phone
      let rep = /^[0-9]+$/;
      if (!rep.test(this.shippingDetails.phone)) {
        this.$swal({
          icon: "error",
          title: "Please key in only number for contact.",
        });
        return false;
      }

      // validate phone min 8 digit      
      if (this.shippingDetails.phone.length < 8) {
        this.$swal({
          icon: "error",
          title: "Please enter minimum 8 digits for Contact.",
        });
        return false;
      }

      return true;
    },

    calCartSubTotal: function () {
      let total = 0;
      this.cart.forEach((item) => {
        total += item.price * item.quantity;
      });
      this.cartSubTotal = total;
    },

    setSpecificCartData: function (cartData) {
      if (this.getCookie("pureeciousCart")) {
        let cartCookie = this.getCookie("pureeciousCart");
        cartCookie.cart_id = cartData.cart_id;
        cartCookie.email = cartData.billing.email;
        cartCookie.payment = "pending";
        this.setCookie("pureeciousCart", JSON.stringify(cartCookie), 1);
      } else {
        this.setCookie(
          "pureeciousCart",
          '{"cart_id": "' +
            cartData.cart_id +
            '", "email": "' +
            cartData.billing.email +
            '", "payment": "pending"}',
          1
        );
      }
      
      this.cart = cartData.products;
      this.cartSubTotal = cartData.total_cart_amount;
      this.cartId = cartData.cart_id;

      let toUpdateCart = false;
      let i;
      this.cart.forEach((data) => {
        this.$set(data, "app_id", this.app_id);
        this.$set(data, "images", [data.image]);
        this.$set(data, "subtotal", data.sub_amount);
        data.quantity = Number(data.quantity);
      });

      for (i = this.cart.length - 1; i >= 0; i--) {
        if (this.products.product) {
          let item = this.products.product.filter(
            (item) => item.id === this.cart[i].id
          );

          if (item.length > 0) {
            this.$set(this.cart[i], "stock_quantity", item[0].stock_quantity);
            if (item[0].selections.length > 0) {
              if (!this.cart[i].variation_id) {
                /** remove invalid item from cart */
                this.removeCartItem(i, this.cart[i]);
                toUpdateCart = true;
              } else {
                let option_list = [];
                this.cart[i].selections = this.cart[i].variations;
                this.cart[i].selections.forEach((vdata) => {
                  vdata.selected_option = vdata.value;
                  option_list.push(vdata.value);
                });
                this.cart[i].option_list = option_list;
              }
            }
          } else {
            /** remove invalid item from cart */
            this.removeCartItem(i, this.cart[i]);
            toUpdateCart = true;
          }
        }
      }

      if (toUpdateCart) {
        if (this.cart.length > 0) {
          this.updateCart();
        }
      }
    },
    showCartModal: function () {
      this.cartModal.show();
    },
    setCookie: function (cname, cvalue, exdays) {
      let d = new Date();
      let item = JSON.parse(cvalue);
      item.expiry = d.getTime() + exdays * 24 * 60 * 60 * 1000;
      localStorage.setItem(cname, JSON.stringify(item));
    },
    getCookie: function (cname) {
      let itemStr = localStorage.getItem(cname);

      // if the item doesn't exist, return null
      if (!itemStr) {
        return false;
      }

      let item = JSON.parse(itemStr);
      let d = new Date();

      // compare the expiry time of the item with the current time
      if (d.getTime() > item.expiry) {
        localStorage.removeItem(cname);
        return null;
      }
      return item;
    },
    getURLParameter: function (name) {
      let queryString = window.location.search;
      let urlParams = new URLSearchParams(queryString);
      if (urlParams.has(name)) {
        return urlParams.get(name);
      } else {
        return false;
      }
    },

    applyPromoCode: function (code) {
      this.promoCode = code;
      if (code != "") {
        this.promoCode = code;
        let promocode = {
          promoCode: code,
        };
        this.setCookie("promoCode", JSON.stringify(promocode), 1);
      } else {
        localStorage.removeItem("promoCode");
      }
      this.promoProcessing = true;
      this.updateCart();
    },

    getItemFromParam: function () {
      if (this.$route.query.quantity) {
        if (this.addItemParam <= 1) {
          this.addItemParam++;
          let quantityParam = this.$route.query.quantity;
          if (this.mainProduct.variations.length == 0 && quantityParam) {
            let i;
            for (i = quantityParam; i > 0; i--) {
              /**if there is stock_quantity */
              if (this.mainProduct.stock_quantity != 0) {
                this.addToCart(this.mainProduct);
              }
            }
          }
        }
      } else {
        //pop up
        if (this.$route.name == "Product") {  
          if(this.$route.params.id == this.mainProduct.id) {        
            this.showProductModal(this.mainProduct);
            this.productModal.show();
          }
        }
      }
    },

    removeProductParam: function () {
      if (this.$route.name == "Product") {
        this.$router.replace("/");
      }
    },

     //check promocode expire date from getCart on first load
    getPromoCode: function (promocode) {
      axios
        .get(this.base_url + "/"+ this.vendor+"/" + "get-promocode", {
          params: {
            promocode: promocode,
          },
        })
        .then((response) => {
          let promoData = response.data;
          let expireDate = promoData.result.date_expires;
          if (expireDate != null) {
            var d_expire = Date.parse(expireDate);
            var d_current = new Date().getTime();
            if (d_expire < d_current) {
              this.updateCart();
            }
          }
        })
        .catch((errors) => {
          console.log(errors);
        });
    },

    hidefaqmodal: function () {
      this.faqModal.hide();
    },

    hidetncmodal: function () {
      this.tncModal.hide();
    },

    updateValue: function (variable, value) {
      this[variable] = value;
    },

    scrollToProduct: function (){
      this.cartModal.hide();
      document.getElementById("product-sec").scrollIntoView();
    }

  },

  mounted() {
    if(this.env_mode){
      console.log(this.env_mode);
    }

    this.cartModal = new bootstrap.Modal(document.getElementById("cartModal"));
    this.productModal = new bootstrap.Modal(document.getElementById("productModal"));
    this.shippingCollapse = new bootstrap.Collapse(
      document.getElementById("collapseOne"),
      { toggle: true }
    );
    this.reviewCollapse = new bootstrap.Collapse(
      document.getElementById("collapseTwo"),
      { toggle: false }
    );
    //app_id from url staging only
    // let payParam = this.getURLParameter("pay");
    // let appParam = this.getURLParameter("app_id"); 

    // if(appParam) {
    //   this.app_id = appParam;
    //   let app_id = {
    //     app_id: appParam,
    //   };
    //   this.setCookie("appId", JSON.stringify(app_id), 1);
    // }
    // else{        
    //   localStorage.removeItem("appId");
    // }

    // if(payParam && !appParam) {
    //   //if redirect from payment page, check local storage
    //   if (this.getCookie("appId")) {
    //     this.app_id = this.getCookie("appId").app_id;
    //     this.$router.push({ query: Object.assign({}, this.$route.query, { app_id: this.app_id }) });          
    //   }  
    // }

    //backend can only except -
    this.vendor = this.vendor.replace(".", "-");
      
    this.getProductList();

    if (this.getCookie("pureeciousCart")) {
      let cartCookie = this.getCookie("pureeciousCart");
      let payParam = this.getURLParameter("pay");

      if (payParam) {
        cartCookie.payment = payParam;
        window.dataLayer = window.dataLayer || [];
        if (payParam == "success") {          

          window.dataLayer.push({ event: "payment-successful" });
          this.$swal({
            icon: "success",
            title:
              "Thank you for your order, you can find the order details at your email " +
              cartCookie.email,          
          });
          
          //add api

          // remove cookie
          localStorage.removeItem("pureeciousCart");
          // remove pay param only
          let query = Object.assign({}, this.$route.query);
          delete query.pay;
          this.$router.replace({ query });
        } else {
          if (payParam == "failed") {
            window.dataLayer.push({ event: "payment-fail" });
            this.$swal({
              icon: "error",
              title: "Oh no, your payment failed. Please try again.",
              text: "If you still encounter any issue, please contact us at ecom.sales@passionation.co",
            });

            // remove pay param after 5s
            var self = this;
            setTimeout(function () {
               // remove param
              let query = Object.assign({}, self.$route.query);
              delete query.pay;
              self.$router.replace({ query });
            }, 5000);
          }

          this.setCookie("pureeciousCart", JSON.stringify(cartCookie), 1);
        }
      }

      if (cartCookie.payment != "success") {
        this.cartId = cartCookie.cart_id;
        this.getCart(true);
      } else {
        // remove cookie
        localStorage.removeItem("pureeciousCart");
        localStorage.removeItem("promoCode");
      }
    }

    this.faqModal = new bootstrap.Modal(document.getElementById("faq"));
    this.tncModal = new bootstrap.Modal(document.getElementById("tnc"));
  },
};
</script>

<style>
#app {
}
</style>
